import React, { useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SectionHeader from "./SectionHeader";
import Slider from "react-slick";
import { exploreData } from "../../api/HomeApi";

gsap.registerPlugin(ScrollTrigger);

const style = {
  sliderItemWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    maxWidth: "548px",
    width: "100%",
  },
  slideContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    margin: "0 8px", // Added margin for gap between slides
  },
  logo: {
    maxWidth: "95%",
    width: "100%",
    height: "auto",
  },
  contentWrapper: {
    width: "100%",
    marginTop: "1.5rem",
  },
  text: {
    welcomeText2: {
      fontFamily: "ZapfHumnst BT",
      fontWeight: "400",
      fontSize: "16px",
      letterSpacing: "0.05em",
      color: "#181818",
    },
    welcomeText3: {
      fontFamily: "ZapfHumnst BT",
      fontWeight: "400",
      fontSize: "24px",
      letterSpacing: "0.05em",
      color: "#181818",
    },
    Description: {
      fontFamily: "Sora",
      fontWeight: "300",
      fontSize: "14px",
      letterSpacing: "1%",
      color: "#4C4C4C",
      width: "90%",
      marginTop: "1rem !important",
    },
  },
  textWrapper: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "95%",
    gap: "4px",
  },
  cont: {
    width: {
      xs: "93%",
      sm: "93%",
      md: "100%",
      lg: "100%",
      xl: "100%",
    },
  },
};

const Explore = () => {
  const sectionHeader = useRef(null);
  const mainContainer = useRef(null);

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3.5,
    slidesToScroll: 1,
    autoplaySpeed: 1000,
    easing: "ease-in-out",
    autoplay: true,
    dots: false,
    swipeToSlide: true,
    draggable: true,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3.2,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2.8,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.8,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  useEffect(() => {
    gsap.fromTo(
      sectionHeader.current,
      { scale: 0.8, opacity: 0 },
      {
        scale: 1,
        opacity: 1,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: mainContainer.current,
          start: "top 80%",
          once: true, 
        },
      }
    );

    gsap.fromTo(
      ".slider-item",
      { scale: 0.8, opacity: 0 },
      {
        scale: 1,
        opacity: 1,
        stagger: 0.1,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: mainContainer.current,
          start: "top 80%",
          once: true,
        },
      }
    );
  }, []);


  return (
    <Box
      ref={mainContainer}
      sx={{
        width: "100%",
        paddingTop: {
          xl: "70px",
          md: "70px",
          sm: "50px",
          xs: "50px",
        },
      }}
    >
      <SectionHeader
        ref={sectionHeader}
        title={"Explore"}
        description={"Nearby Destinations"}
      />
      <Box sx={style.cont} mt={5} mb={5}>
        <Slider {...settings}>
          {exploreData.map((slide, index) => (
            <Box key={index} sx={style.slideContainer}>
              <Box className="slider-item">
                <Box
                  component="img"
                  src={slide.src}
                  alt={`Slide ${index}`}
                  sx={style.logo}
                />
                <Box sx={style.contentWrapper}>
                  <Box sx={style.textWrapper}>
                    <Typography sx={style.text.welcomeText3}>
                      {slide.title}
                    </Typography>
                  </Box>
                  <Typography sx={style.text.Description}>
                    {slide.description}
                  </Typography>
                </Box>
              </Box>
            </Box>
          ))}
        </Slider>
      </Box>
    </Box>
  );
};

export default Explore;